import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    archizeenTileClassName,
    gridClassName,
} from '@archipro-design/aria';

// Class names formerly exported by Aria FeaturedTileSkeleton.
const featuredTileSkeletonClassName = 'ui-featuredTileSkeleton';
const featuredTileSkeletonClassNames = {
    title: `${featuredTileSkeletonClassName}__title`,
};

import { svgIconClassName } from '@archipro-design/icons';

export const Wrap: StyleRule = ({ theme }) => ({
    position: `relative`,
    padding: pxArrayToRem([0, 0, 54, 18]),

    [theme.screen.laptop]: {
        width: '100%',
        padding: 0,
    },
});

export const TitleWrap: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(18),
    ...theme.siteVariables.textStyles.Heading.Roman55,

    [theme.screen.laptop]: {
        margin: 'auto',
        marginBottom: pxToRem(54),
        textAlign: 'center',
    },
});

export const MobileTitle: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Heading.Roman55,
    textTransform: 'uppercase',
    marginBottom: pxToRem(20),
});

export const ButtonSlider: StyleRule = () => ({
    border: 'none',
    [`&.swiper-button-disabled`]: {
        opacity: 0.6,
        pointerEvents: `none`,
    },

    [`& > * > .${svgIconClassName}`]: {
        width: pxToRem(30),
        height: pxToRem(30),
    },
});

export const SliderWrap: StyleRule = () => ({
    overflow: 'hidden',
    margin: pxArrayToRem([0, -14]),
    [`& > ${gridClassName}`]: {
        display: 'grid',
    },
});

export const SlideInner: StyleRule = ({ theme }) => ({
    width: 'inherit',

    [theme.screen.clamped]: {
        width: 'inherit',
    },
});

export const SliderControls: StyleRule = () => ({
    marginTop: pxToRem(16),
    marginBottom: pxToRem(2),
    paddingRight: pxToRem(14),
});

export const Slide = () => ({
    whiteSpace: 'normal',
    display: 'inline-block',
});

export const Slider = () => ({
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    [`& > div`]: {
        display: `flex`,
    },

    [`& .${featuredTileSkeletonClassName}`]: {
        padding: pxToRem(14),
    },

    [`& .${featuredTileSkeletonClassNames.title}`]: {
        display: 'none',
    },
});

export const TileSlide: StyleRule = () => ({
    width: pxToRem(328),
    [`& .${archizeenTileClassName}`]: {
        padding: '0 !important',
    },
});

export const TileSlideWrap: StyleRule = () => ({
    width: 'fit-content',
    gap: pxToRem(14),
});

export const TileSlideOuterWrap: StyleRule = () => ({
    width: '100%',
    overflowX: 'auto',
    paddingRight: pxToRem(18),
    '&::-webkit-scrollbar': {
        height: 0,
    },
});

export const MobilePlaceholderContainer: StyleRule = () => ({
    marginBottom: pxToRem(10),
});

export const PlaceholderGrid = () => ({
    display: 'grid',
});

export const NoSliderClass: StyleRule = () => ({
    marginBottom: pxToRem(80),
});
